import { create } from 'zustand';

// request component store and actions
export const offlineStore = create(() => ({
  actions: {},
}));
export const updateOfflineStore = (data) => offlineStore.setState({ actions: data });
